import { signal } from 'services/SignalsService'
import { SpinCheckService } from 'services/SpinCheckService'
import { subscribe } from 'utils/Subscribe'
import {sendPostMessage} from "../services/PostMessageService";
import {POST_MESSAGE_EVENTS} from "../consts/consts";

const types = {
  400: 'sessionExpired',
  423: 'sessionExpired',
  424: 'sessionExpired',
}

let PopupVisibily = false

const buttons = {
  'BUTTON:ok': () => {
    signal.dispatch('POPUP:close')
    PopupVisibily = false
  },

  'BUTTON:continue': () => {
    game.models.GameModel.requestAgainAllowed = false
    signal.dispatch('POPUP:close')
    PopupVisibily = false
  },

  'BUTTON:adjust': () => {
    SpinCheckService.selectNear()
    signal.dispatch('POPUP:close')
    PopupVisibily = false
  },
  'BUTTON:reload': () => {
    const postMessageEvents = game.models.GameModel.integrationPostMessageEvents;
    const event = postMessageEvents[POST_MESSAGE_EVENTS.RELOAD_ON_ERROR];

    if (event) {
      sendPostMessage(event.eventName);
    }
    else {
      window.top.location.href = game.models.GameModel.home
    }
  },
  'BUTTON:err': () => {
    window.top.location.href = game.models.GameModel.home

  },
  'BUTTON:deposit': () => {
    const postMessageEvents = game.models.GameModel.integrationPostMessageEvents;
    const event = postMessageEvents[POST_MESSAGE_EVENTS.DEPOSIT_OPEN];

    if (event) {
      sendPostMessage(event.eventName);
    }
    else {
      window.top.location.href = game.models.GameModel.deposit
    }
  },
  'BUTTON:GOLD COIN PURCHASE': () => {
    const postMessageEvents = game.models.GameModel.integrationPostMessageEvents;
    const event = postMessageEvents[POST_MESSAGE_EVENTS.DEPOSIT_OPEN];

    if (event) {
      sendPostMessage(event.eventName);
    }
    else {
      window.top.location.href = game.models.GameModel.deposit
    }
  }
}

function status(code) {
  show(types[code] || 'serverError')
}

function show(value) {
  if (PopupVisibily) {
    PopupVisibily = false
    signal.dispatch('POPUP:close')
    setTimeout(() => {
      displayPopup(value)
    }, 500)
  }
  else {
    displayPopup(value)
  }
}

function displayPopup(value) {
  PopupVisibily = true
  signal.dispatch('POPUP:show', value)
}

function init() {
  Object.entries(buttons).forEach(subscribe)
}

export const PopupManager = {
  init,
  show,
  status,
}
